import styled from "styled-components";
import { WrapperContainer } from "../../../components";

export const ConnectedSegmentsTableWrapper = styled(WrapperContainer)`
  tbody {
    min-height: calc(64px * 5) !important;
  }
`;

export const NotConnectedSegmentsTableWrapper = styled(WrapperContainer)`
  tbody {
    min-height: calc(64px * 2) !important;
  }
`;
